/* eslint-disable react/display-name */
import {
  Avatar,
  Badge,
  Button,
  Checkbox,
  Dropdown,
  Menu,
  Popover,
  Space,
  TableColumnType,
  Tooltip,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { DateTimeFormat, DateTimeFormatSimple } from '../../models/datetime'
import { Dimen } from '../../models/dimen'
import { decrypt } from '../../models/m'
import { getPayFlagName, getPayMethodName } from '../..//models/payment'
import { getTransactionQueryName } from '../..//models/TransactionQuery'
import { getCardType } from '../payment/JuhePayPage/columns'
import { ColDef } from 'ag-grid-community'
import styles from './prescriptionManagement.module.css'
import { getGenderName } from '../../models/user'
import { getAge } from '../../utils/StringUtils'
import { getRecipeState } from '../../models/prescriptionManagement'
import { useSelector } from 'react-redux'
import { selectStationCategory, selectRole } from '../../app/applicationSlice'

type Action =
  | 'repeal'
  | 'detail'
  | 'print'
  | 'supplementary'


export const AGColumns = (
  startIndex?: any,
  onAction?: (
    action: Action,
    t: any,
  ) => void,
  columnList?: any,
): ColDef[] => {
  const stationCategory = useSelector(selectStationCategory)
  const role = useSelector(selectRole)

  const menu = (p: any) => (
    <Menu>
      {p?.recipeState == '3' ? (
        <Menu.Item>
          已允许退费
        </Menu.Item>
      ) : <Menu.Item onClick={() => onAction && onAction('supplementary', p)}>
        允许退费
      </Menu.Item>}

    </Menu>
  )
  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'index':
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) {
                return ''
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        case 'tenantName': //机构名称
          return {
            ...item,
            headerClass: styles.leftAligned,
            cellStyle: { textAlign: 'left' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              // 处理 pinned row（合计行）
              if (params.node.rowPinned) {
                return ''
              }
              return (
                <div>
                  {t?.tenantName ? t?.tenantName : '-'}
                </div>
              );
            }
          };
        case 'patientName': //患者姓名
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              // 处理 pinned row（合计行）
              if (params.node.rowPinned) {
                return ''
              }
              return (
                <div>
                  {t?.patientName ? t?.patientName : '-'}
                </div>
              );
            }
          };
        case 'insuranceCode': //结算险种
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const { value } = params;
              if (params.node.rowPinned) return '';
              return value === 'ZIFEI' || !value ? '自费' : '智慧医保';
            },
          };
        case 'sex': //性别
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const patient = params.data
              return getGenderName(patient.sex) || '-';
            },
          };
        case 'ageYear': //年龄
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data
              return getAge(t?.ageYear, t?.ageMonth);
            },
          };
        case 'disease': //疾病名称
          return {
            ...item,
            headerClass: styles.leftAligned,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'left',
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value || '-';
            },
          };
        case 'doctorName': //就诊医生
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value || '-';
            },
          };
        case 'tip': //帖数
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value || '-';
            },
          };
        case 'amount': //处方金额
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value ? params.value?.toFixed(2) : '-';
            },
          };
        case 'payTime': //结算时间
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value ? moment(params.value)?.format(DateTimeFormat) : '-';
            },
          };
        case 'recipeState': //状态
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.recipeState == 5 ? '#999999' : '#333333',
              }
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value?.toString() ? getRecipeState((params.value)?.toString()) : '-';
            },
          };
        case 'action':
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              // 确保只在合适的状态下显示退费按钮，避免重复显示
              return (
                <>
                  {/* 未代煎 */}
                  {t?.recipeState == '0' ?
                    <Button
                      size='small'
                      type='link'
                      onClick={() => onAction && onAction('repeal', t)}
                    >
                      代煎
                    </Button> : <></>
                  }
                  <Button
                    size='small'
                    type='link'
                    onClick={() => onAction && onAction('detail', t)}
                  >
                    详情
                  </Button>
                  <Button
                    size='small'
                    type='link'
                    onClick={() => onAction && onAction('print', t)}
                  >
                    打印
                  </Button>
                  {t?.recipeState == '5' ? <></>
                    : (stationCategory == 13 || role == 1) &&
                    <Dropdown overlay={menu(t)} trigger={['click']}>
                      <Button
                        size='small'
                        type='link'
                      >
                        更多
                      </Button>
                    </Dropdown>}
                </>
              );
            }
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
          };
      }
    })
  )
}

